const STORE_CAROUSEL_PREFIX = "StoreCarousel";

export const STORE_CAROUSEL_CLASSES = {
  elementWrapper: `${STORE_CAROUSEL_PREFIX}-elementWrapper`,
  element: `${STORE_CAROUSEL_PREFIX}-element`,
  elements: `${STORE_CAROUSEL_PREFIX}-elements`,
};
